export default __webpack_public_path__ + "static/media/Group-7455.b1baedcc.png";